import { Box, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NirantaraIcon from "../assets/images/vajra.svg";
import { getConsultantIconUrl } from "../utils/consultantLogo";
import {
  miniSidebarElements,
  sidebarElements1,
  sidebarElementsFacility,
} from "../utils/constant";
import electricitymaster from "../assets/images/Sidebar/electricitymaster.svg";
import styles from "../styles/layout/grisidebar.module.css";
import SidebarItemsRenderer from "../utils/layoutFunctions";
// import { useGRI } from "../context/GRIContext";
import useGRIStore from "../store/GRIstore";
import { get } from "../utils/api";
import { useUser } from "../context/AuthContext";
import {
  filterMiniSidebarElements,
  getRoleBasedSidebar,
} from "../utils/sidebarFunctions";

const GRISidebar = () => {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const [disable, setDisable] = useState(true);
  const { id } = useParams();

  // const { griId } = useGRI();
  const { selectedGRI } = useGRIStore();

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    if (!sidebarEl) return;

    const handleScroll = () => {
      localStorage.setItem("sidebarScrollTop", sidebarEl.scrollTop);
    };

    sidebarEl.addEventListener("scroll", handleScroll);

    return () => {
      sidebarEl.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    const savedScrollTop = localStorage.getItem("sidebarScrollTop");

    if (sidebarEl && savedScrollTop) {
      sidebarEl.scrollTop = parseInt(savedScrollTop, 10);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      console.log(id, "id");
      try {
        const response = await get(`/gri/get/status?id=${id}`);
        if (response?.data?.griSubmitted === false) {
          console.log(response?.data?.griSubmitted, "response1");
          setDisable(true);
        } else {
          setDisable(false);
        }
        console.log(response?.data?.brsrSubmitted, "response1");
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [id]);

  const [open, setOpen] = useState({});

  const [activeChild, setActiveChild] = useState(null);
  const [activeSubChild, setActiveSubChild] = useState(null);
  const [expandedSection, setExpandedSection] = useState(null);

  const activeSectionRef = useRef(null);
  const activeChildRef = useRef(null);
  const activeSubChildRef = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedSection = mastersSidebarElements.find((section) =>
      currentPath.startsWith(section.match)
    );
    if (matchedSection) {
      setExpandedSection({ header: matchedSection.text });
      const matchedChild = matchedSection.children
        .slice()
        .sort((a, b) => b.path.length - a.path.length)
        .find((child) => currentPath.startsWith(child.match));

      if (matchedChild) {
        setActiveChild(matchedChild.text);
        const matchedSubChild = matchedChild.subChildren?.find(
          (subChild) => currentPath === subChild.path
        );
        setActiveSubChild(matchedSubChild ? matchedSubChild.text : null);
      } else {
        setActiveChild(null);
        setActiveSubChild(null);
      }
    } else {
      setExpandedSection(null);
      setActiveChild(null);
      setActiveSubChild(null);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (activeSubChildRef.current) {
      activeSubChildRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    } else if (activeChildRef.current) {
      activeChildRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    } else if (activeSectionRef.current) {
      activeSectionRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  }, [expandedSection, activeChild, activeSubChild]);

  const handleSectionClick = (item) => {
    setExpandedSection(
      expandedSection?.header === item.text ? null : { header: item.text }
    );
    // navigate(`${item.children[0].path}/${griId}`);
    if (item.children && item.children.length > 0) {
      navigate(`${item.children[0].path}/${id}`);
    } else {
      navigate(`/gri/review/${id}`);
    }
  };

  const handleChildClick = (child) => {
    if (activeChild === child.text) {
      setActiveChild(null);
      setActiveSubChild(null);
    } else {
      setActiveChild(child.text);
      setActiveSubChild(child.subChildren?.[0]?.text || null);
      navigate(`${child.subChildren?.[0]?.path}/${id}`);
    }
  };

  const handleSubChildClick = (subChild, child) => {
    setActiveSubChild(subChild?.text);
    setActiveChild(child?.text);

    if (location.pathname !== subChild.path) {
      navigate(`${subChild.path}/${id}`);
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = mastersSidebarElements.find((item) =>
      currentPath.startsWith(item.path)
    );

    if (matchedItem) {
      setOpen({
        index: mastersSidebarElements.indexOf(matchedItem),
        header: matchedItem.text,
      });
    }
  }, [location.pathname]);

  const mastersSidebarElements = [
    {
      text: "General Disclosure 2021",
      icon: electricitymaster,
      path: "/gri/general-disclosure",
      match: "/gri/general-disclosure/2",
      children: [
        {
          text: "2-1: Organizational Details",
          path: "/gri/general-disclosure/2-1",
          match: "/gri/general-disclosure/2-1",
        },
        {
          text: "2-2: Entities included in the organization's sustainability reporting",
          path: "/gri/general-disclosure/2-2",
          match: "/gri/general-disclosure/2-2",
        },
        {
          text: "2-3: Reporting period, frequency and contact point",
          path: "/gri/general-disclosure/2-3",
          match: "/gri/general-disclosure/2-3",
        },
        {
          text: "2-4: Restatements of information",
          path: "/gri/general-disclosure/2-4",
          match: "/gri/general-disclosure/2-4",
        },
        {
          text: "2-5: External assurance",
          path: "/gri/general-disclosure/2-5",
          match: "/gri/general-disclosure/2-5",
        },
        {
          text: "2-6: Activities, value chain and other business relationships",
          path: "/gri/general-disclosure/2-6",
          match: "/gri/general-disclosure/2-6",
        },
        {
          text: "2-7: Employees",
          path: "/gri/general-disclosure/2-7",
          match: "/gri/general-disclosure/2-7",
        },
        {
          text: "2-8: Workers who are not employees",
          path: "/gri/general-disclosure/2-8",
          match: "/gri/general-disclosure/2-8",
        },
        {
          text: "2-9: Governance structure and composition",
          path: "/gri/general-disclosure/2-9",
          match: "/gri/general-disclosure/2-9",
        },
        {
          text: "2-10: Nomination and selection of the highest governance body",
          path: "/gri/general-disclosure/2-10",
          match: "/gri/general-disclosure/2-10",
        },
        {
          text: "2-11: Chair of the highest governance body",
          path: "/gri/general-disclosure/2-11",
          match: "/gri/general-disclosure/2-11",
        },
        {
          text: "2-12: Role of the highest governance body in overseeing the management of impacts",
          path: "/gri/general-disclosure/2-12",
          match: "/gri/general-disclosure/2-12",
        },
        {
          text: "2-13: Delegation of responsibility for managing impacts",
          path: "/gri/general-disclosure/2-13",
          match: "/gri/general-disclosure/2-13",
        },
        {
          text: "2-14: Role of the highest governance body in sustainability reporting",
          path: "/gri/general-disclosure/2-14",
          match: "/gri/general-disclosure/2-14",
        },
        {
          text: "2-15: Conflicts of interest",
          path: "/gri/general-disclosure/2-15",
          match: "/gri/general-disclosure/2-15",
        },
        {
          text: "2-16: Communication of critical concerns",
          path: "/gri/general-disclosure/2-16",
          match: "/gri/general-disclosure/2-16",
        },
        {
          text: "2-17: Collective knowledge of the highest governance body",
          path: "/gri/general-disclosure/2-17",
          match: "/gri/general-disclosure/2-17",
        },
        {
          text: "2-18: Evaluation of the performance of the highest governance body",
          path: "/gri/general-disclosure/2-18",
          match: "/gri/general-disclosure/2-18",
        },
        {
          text: "2-19: Remuneration policies",
          path: "/gri/general-disclosure/2-19",
          match: "/gri/general-disclosure/2-19",
        },
        {
          text: "2-20: Process to determine remuneration",
          path: "/gri/general-disclosure/2-20",
          match: "/gri/general-disclosure/2-20",
        },
        {
          text: "2-21: Annual total compensation ratio",
          path: "/gri/general-disclosure/2-21",
          match: "/gri/general-disclosure/2-21",
        },
        {
          text: "2-22: Statement on sustainable development strategy",
          path: "/gri/general-disclosure/2-22",
          match: "/gri/general-disclosure/2-22",
        },
        {
          text: "2-23: Policy commitments",
          path: "/gri/general-disclosure/2-23",
          match: "/gri/general-disclosure/2-23",
        },
        {
          text: "2-24: Embedding policy commitments",
          path: "/gri/general-disclosure/2-24",
          match: "/gri/general-disclosure/2-24",
        },
        {
          text: "2-25: Processes to remediate negative impacts",
          path: "/gri/general-disclosure/2-25",
          match: "/gri/general-disclosure/2-25",
        },
        {
          text: "2-26: Mechanisms for seeking advice and raising concerns",
          path: "/gri/general-disclosure/2-26",
          match: "/gri/general-disclosure/2-26",
        },
        {
          text: "2-27: Compliance with laws and regulations",
          path: "/gri/general-disclosure/2-27",
          match: "/gri/general-disclosure/2-27",
        },
        {
          text: "2-28: Membership associations",
          path: "/gri/general-disclosure/2-28",
          match: "/gri/general-disclosure/2-28",
        },
        {
          text: "2-29: Approach to stakeholder engagement",
          path: "/gri/general-disclosure/2-29",
          match: "/gri/general-disclosure/2-29",
        },
        {
          text: "2-30: Collective bargaining agreements",
          path: "/gri/general-disclosure/2-30",
          match: "/gri/general-disclosure/2-30",
        },
      ],
    },
    {
      text: "GRI 200",
      icon: electricitymaster,
      path: "/gri/economic-performance/201-1",
      match: "/gri/economic-performance/20",
      children: [
        {
          text: "201: Economic Performance",
          path: "/gri/economic-performance/201-1",
          match: "/gri/economic-performance/201",
          subChildren: [
            {
              text: "201-1: Direct economic value generated and distributed",
              path: "/gri/economic-performance/201-1",
            },
            {
              text: "201-2: Financial implications and other risks and opportunities due to climate change",
              path: "/gri/economic-performance/201-2",
            },
            {
              text: "201-3: Defined benefit plan obligations and other retirement plans",
              path: "/gri/economic-performance/201-3",
            },
            {
              text: "201-4: Financial assistance received from government",
              path: "/gri/economic-performance/201-4",
            },
          ],
        },
        {
          text: "202: Market Presence 2016",
          path: "/gri/economic-performance/202-1",
          match: "/gri/economic-performance/202",
          subChildren: [
            {
              text: "202-1: Ratios of standard entry level wage by gender compared to local minimum wage",
              path: "/gri/economic-performance/202-1",
            },
            {
              text: "202-2: Proportion of senior management hired from the local community",
              path: "/gri/economic-performance/202-2",
            },
          ],
        },
        {
          text: "203: Indirect Economic Impact",
          path: "/gri/economic-performance/203-1",
          match: "/gri/economic-performance/203",
          subChildren: [
            {
              text: "203-1: Infrastructure investments and services supported",
              path: "/gri/economic-performance/203-1",
            },
            {
              text: "203-2: Significant indirect economic impacts",
              path: "/gri/economic-performance/203-2",
            },
          ],
        },
        {
          text: "204: Procurement Practices 2016",
          path: "/gri/economic-performance/204-1",
          match: "/gri/economic-performance/204",
          subChildren: [
            {
              text: "204-1: Significant indirect economic impacts",
              path: "/gri/economic-performance/204-1",
            },
          ],
        },
        {
          text: "205: Anti-corruption 2016",
          path: "/gri/economic-performance/205-1",
          match: "/gri/economic-performance/205",
          subChildren: [
            {
              text: "205-1: Operations assessed for risks related to corruption",
              path: "/gri/economic-performance/205-1",
            },
            {
              text: "205-2: Communication and training about anti-corruption policies and procedures",
              path: "/gri/economic-performance/205-2",
            },
            {
              text: "205-3: Confirmed incidents of corruption and action taken",
              path: "/gri/economic-performance/205-3",
            },
          ],
        },
        {
          text: "206: Anti-competitive Behaviour 2016",
          path: "/gri/economic-performance/206-1",
          match: "/gri/economic-performance/206",
          subChildren: [
            {
              text: "206-1: Legal actions for anti-competitive behavior, anti-trust, and monopoly practices",
              path: "/gri/economic-performance/206-1",
            },
          ],
        },
        {
          text: "207: Tax 2019",
          path: "/gri/economic-performance/207-1",
          match: "/gri/economic-performance/207",
          subChildren: [
            {
              text: "207-1: Approach to tax",
              path: "/gri/economic-performance/207-1",
            },
            {
              text: "207-2: Tax governance, control and risk management",
              path: "/gri/economic-performance/207-2",
            },
            {
              text: "207-3: Stakeholder engagement and management of concerns related to tax",
              path: "/gri/economic-performance/207-3",
            },
            {
              text: "207-4: Country-by-country reporting",
              path: "/gri/economic-performance/207-4",
            },
          ],
        },
      ],
    },
    {
      text: "GRI 300",
      icon: electricitymaster,
      path: "/gri/gri300/301-1",
      match: "/gri/gri300",
      children: [
        {
          text: "301: Material Used",
          path: "/gri/gri300/301-1",
          match: "/gri/gri300/301",
          subChildren: [
            {
              text: "301-1: Materials used by weight or volume",
              path: "/gri/gri300/301-1",
            },
            {
              text: "301-2: Recycled input materials used",
              path: "/gri/gri300/301-2",
            },
            {
              text: "301-3: Reclaimed products and their packaging materials",
              path: "/gri/gri300/301-3",
            },
          ],
        },
        {
          text: "302: Energy",
          path: "/gri/gri300/302-1",
          match: "/gri/gri300/302",
          subChildren: [
            {
              text: "302-1: Energy consumption within the organization",
              path: "/gri/gri300/302-1",
            },
            {
              text: "302-2: Energy consumption outside of the organization",
              path: "/gri/gri300/302-2",
            },
            {
              text: "302-3: Energy intensity",
              path: "/gri/gri300/302-3",
            },
            {
              text: "302-4: Reduction of energy consumption",
              path: "/gri/gri300/302-4",
            },
            {
              text: "302-5: Reductions in energy requirements of products and services",
              path: "/gri/gri300/302-5",
            },
          ],
        },
        {
          text: "303: Water & Effluents",
          path: "/gri/gri300/303-1",
          match: "/gri/gri300/303",
          subChildren: [
            {
              text: "303-1: Interactions with water as  a shared resource",
              path: "/gri/gri300/303-1",
            },
            {
              text: "303-2: Management of water discharge related impacts",
              path: "/gri/gri300/303-2",
            },
            {
              text: "303-3: Water Withdrawal",
              path: "/gri/gri300/303-3",
            },
            {
              text: "303-4: Water Discharge",
              path: "/gri/gri300/303-4",
            },
            {
              text: "303-5: Water Consumption",
              path: "/gri/gri300/303-5",
            },
          ],
        },
        {
          text: "304: Biodiversity",
          path: "/gri/gri300/304-1",
          match: "/gri/gri300/304",
          subChildren: [
            {
              text: "304-1: Operational sites",
              path: "/gri/gri300/304-1",
            },
            {
              text: "304-2: Significant impacts of activities, products and services on biodiversity",
              path: "/gri/gri300/304-2",
            },
            {
              text: "304-3: Habitats protected or restored",
              path: "/gri/gri300/304-3",
            },
            {
              text: "304-4: IUCN Red List species and national conservation list species with habitats in areas affected by operations",
              path: "/gri/gri300/304-4",
            },
          ],
        },
        {
          text: "305: Emissions",
          path: "/gri/gri300/305-1",
          match: "/gri/gri300/305",
          subChildren: [
            {
              text: "305-1: Direct (Scope 1) GHG emissions",
              path: "/gri/gri300/305-1",
            },
            {
              text: "305-2: Energy indirect (Scope 2) GHG emissions",
              path: "/gri/gri300/305-2",
            },
            {
              text: "305-3: Other indirect (Scope 3) GHG emissions",
              path: "/gri/gri300/305-3",
            },
            {
              text: "305-4: GHG emissions intensity",
              path: "/gri/gri300/305-4",
            },
            {
              text: "305-5: Reduction of GHG emissions",
              path: "/gri/gri300/305-5",
            },
            {
              text: "305-6: Emissions of ozone-depleting substances (ODS)",
              path: "/gri/gri300/305-6",
            },
            {
              text: "305-7: Nitrogen oxides (NOx), sulfur oxides (SOx), and other significant air emissions",
              path: "/gri/gri300/305-7",
            },
          ],
        },
        {
          text: "306: Waste",
          path: "/gri/gri300/306-1",
          match: "/gri/gri300/306",
          subChildren: [
            {
              text: "306-1: Waste generation and significant waste-related impacts",
              path: "/gri/gri300/306-1",
            },
            {
              text: "306-2: Management of significant wasterelated impacts",
              path: "/gri/gri300/306-2",
            },
            {
              text: "306-3: Waste generated",
              path: "/gri/gri300/306-3",
            },
            {
              text: "306-4: Waste diverted from disposal ",
              path: "/gri/gri300/306-4",
            },
            {
              text: "306-5: Waste directed to disposal",
              path: "/gri/gri300/306-5",
            },
          ],
        },
        {
          text: "308: Supplier Environmental Assessment",
          path: "/gri/gri300/308-1",
          match: "/gri/gri300/308",
          subChildren: [
            {
              text: "308-1: New suppliers that were screened using environmental criteria",
              path: "/gri/gri300/308-1",
            },
            {
              text: "308-2: Negative environmental impacts in the supply chain and actions taken",
              path: "/gri/gri300/308-2",
            },
          ],
        },
      ],
    },
    {
      text: "GRI 400",
      icon: electricitymaster,
      path: "/gri/gri400/401-1",
      match: "/gri/gri400",
      children: [
        {
          text: "401: Material Used",
          path: "/gri/gri400/401-1",
          match: "/gri/gri400/401",
          subChildren: [
            {
              text: "401-1: New employee hires and employee turnover",
              path: "/gri/gri400/401-1",
            },
            {
              text: "401-2: Benefits provided to full-time employees that are not provided to temporary or part time employees",
              path: "/gri/gri400/401-2",
            },
            {
              text: "401-3: Parental Leaves",
              path: "/gri/gri400/401-3",
            },
          ],
        },
        {
          text: "402: Labour Management Relations",
          path: "/gri/gri400/402-1",
          match: "/gri/gri400/402",
          subChildren: [
            {
              text: "402-1: Minimum Notice Periods regarding operational changes",
              path: "/gri/gri400/402-1",
            },
          ],
        },
        {
          text: "403: Occupational Health and Safety",
          path: "/gri/gri400/403-1",
          match: "/gri/gri400/403",
          subChildren: [
            {
              text: "403-1: Occupational health and safety management system",
              path: "/gri/gri400/403-1",
            },
            {
              text: "403-2: Hazard identification, risk assessment, and incident investigation",
              path: "/gri/gri400/403-2",
            },
            {
              text: "403-3: Occupational health services",
              path: "/gri/gri400/403-3",
            },
            {
              text: "403-4 Worker participation, consultation, and communication on occupational health and safety",
              path: "/gri/gri400/403-4",
            },
            {
              text: "403-5 Worker training on occupational health and safety",
              path: "/gri/gri400/403-5",
            },
            {
              text: "403-6 Promotion of worker health",
              path: "/gri/gri400/403-6",
            },
            {
              text: "403-7: Prevention and mitigation of occupational health and safety impacts directly linked by business relationships",
              path: "/gri/gri400/403-7",
            },
            {
              text: "403-8 Workers covered by an occupational health and safety management system",
              path: "/gri/gri400/403-8",
            },
            {
              text: "403-9 Work-related injuries",
              path: "/gri/gri400/403-9",
            },
            {
              text: "403-10 Work-related ill health",
              path: "/gri/gri400/403-10",
            },
          ],
        },
        {
          text: "404: Training and Education",
          path: "/gri/gri400/404-1",
          match: "/gri/gri400/404",
          subChildren: [
            {
              text: "404-1: Average hours of training per year per employee",
              path: "/gri/gri400/404-1",
            },
            {
              text: "404-2: Programs for upgrading employee skills and transition assistance programs",
              path: "/gri/gri400/404-2",
            },
            {
              text: "404-3: Percentage of employees receiving regular performance and career development reviews",
              path: "/gri/gri400/404-3",
            },
          ],
        },
        {
          text: "405: Diversity and Equal Opportunity",
          path: "/gri/gri400/405-1",
          match: "/gri/gri400/405",
          subChildren: [
            {
              text: "405-1: Diversity of governance bodies and employees",
              path: "/gri/gri400/405-1",
            },
            {
              text: "405-2 Ratio of basic salary and remuneration of women to men",
              path: "/gri/gri400/405-2",
            },
          ],
        },
        {
          text: "406: Non Discrimination",
          path: "/gri/gri400/406-1",
          match: "/gri/gri400/406",
          subChildren: [
            {
              text: "406-1: Incidents of discimination and corrective actions taken",
              path: "/gri/gri400/406-1",
            },
          ],
        },
        {
          text: "407: Freedom of Association",
          path: "/gri/gri400/407-1",
          match: "/gri/gri400/407",
          subChildren: [
            {
              text: "407-1: Operations and suppliers in which the right to freedom of association and collective bargaining may be at risk",
              path: "/gri/gri400/407-1",
            },
          ],
        },
        {
          text: "408: Child Labour",
          path: "/gri/gri400/408-1",
          match: "/gri/gri400/408",
          subChildren: [
            {
              text: "408-1: Operations and suppliers at significant at significant risk for incidents of child labor",
              path: "/gri/gri400/408-1",
            },
          ],
        },
        {
          text: "409: Forced or Compulsory Labour",
          path: "/gri/gri400/409-1",
          match: "/gri/gri400/409",
          subChildren: [
            {
              text: "409-1: Operations and suppliers at significant risk for incidents of forced or compulsory labor",
              path: "/gri/gri400/409-1",
            },
          ],
        },
        {
          text: "410: Security Practices 2016",
          path: "/gri/gri400/410-1",
          match: "/gri/gri400/410",
          subChildren: [
            {
              text: "410-1: Security personnel trained in human rights policies or procedures",
              path: "/gri/gri400/410-1",
            },
          ],
        },
        {
          text: "411: Rights of Indigenous People",
          path: "/gri/gri400/411-1",
          match: "/gri/gri400/411",
          subChildren: [
            {
              text: "411-1: Incedents of violations involving rights of indigenous peoples",
              path: "/gri/gri400/411-1",
            },
          ],
        },
        // {
        //   text: "412: Human Rights Assessment",
        //   path: "/gri/gri400/412-1",
        //   match: "/gri/gri400/412",
        //   subChildren: [
        //     {
        //       text: "system",
        //       path: "/gri/gri400/412-1",
        //     },
        //   ],
        // },
        {
          text: "413: Local Communities",
          path: "/gri/gri400/413-1",
          match: "/gri/gri400/413",
          subChildren: [
            {
              text: "413-1 Operations with local community engagement, impact assessments, and development programs",
              path: "/gri/gri400/413-1",
            },
            {
              text: "413-2 Operations with significant actual and potential negative impacts on local communities",
              path: "/gri/gri400/413-2",
            },
          ],
        },
        {
          text: "414: Supplier Social Assessment",
          path: "/gri/gri400/414-1",
          match: "/gri/gri400/414",
          subChildren: [
            {
              text: "414-1 New suppliers that were screened using social criteria",
              path: "/gri/gri400/414-1",
            },
            {
              text: "414-2 Negative social impacts in the supply chain and actions taken",
              path: "/gri/gri400/414-2",
            },
          ],
        },
        {
          text: "415: Public Policy",
          path: "/gri/gri400/415-1",
          match: "/gri/gri400/415",
          subChildren: [
            {
              text: "415-1 Political contributions",
              path: "/gri/gri400/415-1",
            },
          ],
        },
        {
          text: "416: Customer Health & Safety",
          path: "/gri/gri400/416-1",
          match: "/gri/gri400/416",
          subChildren: [
            {
              text: "416-1 Assessment of the health and safety impacts of products and service categories",
              path: "/gri/gri400/416-1",
            },
            {
              text: "416-2 Incidents of non-compliance concerning the health and safety impacts of products and services",
              path: "/gri/gri400/416-2",
            },
          ],
        },
        {
          text: "417: Marketing & Labelling",
          path: "/gri/gri400/417-1",
          match: "/gri/gri400/417",
          subChildren: [
            {
              text: "417-1 Requirements of product and service information and labelling",
              path: "/gri/gri400/417-1",
            },
            {
              text: "417-2 Incidents of non-compliance concerning product and service information and labelling",
              path: "/gri/gri400/417-2",
            },
            {
              text: "417-3 Incidents of non-compliance concerning marketing communications",
              path: "/gri/gri400/417-3",
            },
          ],
        },
        {
          text: "418: Customer Privacy",
          path: "/gri/gri400/418-1",
          match: "/gri/gri400/418",
          subChildren: [
            {
              text: "418-1 Substantiated complaints concerning breaches of customer privacy and losses of customer data",
              path: "/gri/gri400/418-1",
            },
          ],
        },
      ],
    },
    ...(!disable
      ? [
          {
            text: "Review and Submit",
            path: "/gri/review",
          },
        ]
      : []),
  ];

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = sidebarElements.map((item) => {
    if (item.path === "/production-revenue") {
      return {
        ...item,
        heading: user?.companyAdmin ? "Production & Revenue" : "Production",
      };
    }
    if (item.heading === "Setup" && item.subData) {
      const newSubData = item.subData.filter(
        (sub) => sub.primary !== "Facility Master" || !user?.facility
      );
      return { ...item, subData: newSubData };
    }
    return item;
  });

  const miniSidebarFiltered = filterMiniSidebarElements({
    user,
    miniSidebarElements,
  });

  const renderMainSidebarItems = (elements) => {
    return elements.map((item, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          marginTop: "0rem",
        }}
      >
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              item.primary === "ESG Reporting" ? "#1C486B" : "transparent",
          }}
        >
          <Tooltip
            title={item.title}
            arrow
            placement="bottom-start"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#fff",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "0.25rem 0.5rem",
                },
                arrow: {
                  color: "#fff",
                },
              },
            }}
          >
            <a
              href={item.path}
              key={item.primary}
              style={{
                textDecoration: "none",
                color: "green",
                padding: "0.4rem",
                borderRadius: "4px",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  width: "24px",
                  height: "24px",
                  filter: location.pathname.startsWith(item.pathLink2)
                    ? "invert(1)"
                    : "invert(0)",
                }}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    ));
  };

  const renderSecondarySidebarItems = (elements, heading) => {
    return (
      <div style={{ width: "100%", fontFamily: "Inter", marginTop: "1.5rem" }}>
        {heading && <p className={styles.sidebarHeading}>{heading}</p>}
        <div className={styles.progressBarDiv}>
          {/* <progress
            id="file"
            value="10"
            max="100"
            className={styles.progressBar}
          />
          <p className={styles.progressbar_value}>10%</p> */}
        </div>
        <div style={{ padding: "0 0.75rem" }}>
          {elements.map((item, index) => (
            <div key={`item-${index}`}>
              <div
                ref={
                  expandedSection?.header === item.text
                    ? activeSectionRef
                    : null
                }
                onClick={() => handleSectionClick(item)}
                className={styles.sidebarHeader}
                style={{
                  color:
                    expandedSection?.header === item.text ? "white" : "black",
                  backgroundColor:
                    expandedSection?.header === item.text ? "#EB7E0E" : "white",
                }}
              >
                <span>{item.text}</span>
                {item.text !== "Review and Submit" && (
                  <span style={{ marginLeft: "auto", fontSize: "20px" }}>
                    {expandedSection?.header === item.text ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </span>
                )}
              </div>

              {item.children && expandedSection?.header === item.text && (
                <div
                  style={{ position: "relative", margin: "1rem 0 1rem 1rem" }}
                >
                  {item.children.map((child, childIndex) => (
                    <div
                      key={`child-${childIndex}`}
                      style={{ position: "relative" }}
                    >
                      {/* Timeline Dot for Child */}
                      <div className={styles.timelineDot}></div>

                      {/* Child Item */}
                      <div
                        ref={activeChild === child.text ? activeChildRef : null}
                        onClick={() => {
                          if (
                            child.subChildren &&
                            child.subChildren.length > 0
                          ) {
                            handleChildClick(child);
                          } else {
                            navigate(`${child.path}/${id}`);
                          }
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "1rem",
                          cursor: "pointer",
                          fontWeight:
                            activeChild === child.text ? "bold" : "normal",
                          color:
                            activeChild === child.text ? "#EB7E0E" : "#fff",
                        }}
                      >
                        <p className={styles.timelineText}>{child.text}</p>
                      </div>

                      {/* SubChildren Section - Only Show If Child Is Active */}
                      {child.subChildren && activeChild === child.text && (
                        <div style={{ marginLeft: "0rem" }}>
                          {child.subChildren.map((subChild, subChildIndex) => (
                            <div
                              key={`subChild-${subChildIndex}`}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                              }}
                            >
                              {/* Small Timeline Dot for SubChildren */}
                              <div className={styles.subChildDot}></div>

                              {/* SubChild Item */}
                              <div
                                ref={
                                  activeSubChild === subChild.text
                                    ? activeSubChildRef
                                    : null
                                }
                                onClick={() =>
                                  handleSubChildClick(subChild, child)
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  fontWeight:
                                    activeSubChild === subChild.text
                                      ? "bold"
                                      : "normal",
                                  color:
                                    activeSubChild === subChild?.text
                                      ? "#EB7E0E"
                                      : "#fff",
                                }}
                              >
                                <p className={styles.subChildText}>
                                  {subChild.text}
                                </p>
                              </div>

                              {!(
                                childIndex === item.children.length - 1 &&
                                subChildIndex === child.subChildren.length - 1
                              ) && (
                                <div className={styles.subChildConnector}></div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      {childIndex !== item.children.length - 1 && (
                        <div className={styles.subChildConnector}></div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <Box style={{ display: "flex" }}>
        <div
          style={{
            width: "22.5%",
            backgroundColor: "#E6E6E6",
            maxHeight: "100vh",
            overflowY: "auto",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Box display="flex" justifyContent="center" p={2}>
            <img
              src={getConsultantIconUrl() || NirantaraIcon}
              alt="Nirantara Logo"
              style={
                getConsultantIconUrl()
                  ? { cursor: "pointer", height: "30px", width: "30px", objectFit: "contain" }
                  : { cursor: "pointer", height: "44px", width: "auto", objectFit: "contain" }
              }
              onClick={() => navigate("/dashboard")}
            />
          </Box>
          <div style={{ width: "100%" }}>
            {renderMainSidebarItems(miniSidebarFiltered)}
          </div>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "21.3vw",
              maxHeight: "100vh",
              backgroundColor: "#fff",
              zIndex: 10,
              overflowY: "auto",
              transform: isHovered ? "translateX(0)" : "translateX(-100%)",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.4s ease, transform 0.4s ease",
              pointerEvents: isHovered ? "auto" : "none",
              willChange: "transform, opacity",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {<SidebarItemsRenderer elements={filteredSidebar} />}
          </div>
        </div>
        <div
          ref={sidebarRef}
          style={{
            backgroundColor: "#1C486B",
            width: "77.5%",
            overflowY: "auto",
            maxHeight: "100vh",
          }}
        >
          {renderSecondarySidebarItems(mastersSidebarElements, "GRI Report")}
        </div>
      </Box>
    </>
  );
};

export default GRISidebar;
